import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import "react-credit-cards/es/styles-compiled.css";
import Cards from "react-credit-cards";

function OrderDetail({ cardInfo, setCardInfo, checkout }) {
  const [number, setNumber] = useState("");
  const [name, setName] = useState("");
  const [expiry, setExpiry] = useState("");
  const [cvc, setCvc] = useState("");
  const [focus, setFocus] = useState("");

  const items = useSelector((state) => state.shoppingCart);
  const totalPrice = useSelector((state) =>
    state.shoppingCart.reduce((acc, item) => acc + item.price * item.quantity || 1, 0),
  );
  const sendCost = useSelector((state) => state.sendCost);

  const updatCardInfo = (e) => {
    setCardInfo({
      ...cardInfo,
      [e.target.name]: e.target.value,
    });
  };

  const handdleSubmit = (e) => {
    e.preventDefault();
    checkout();
  };

  useEffect(() => {
    ref.current.focus();
  }, []);

  const ref = useRef(null);

  return (
    <>
      <Card>
        <Card.Body>
          <h5 className="fw-bold fs-6">TU PEDIDO</h5>
          <br />
          <hr />
          <div className="table-responsive">
            <table className="table table-checkout">
              <thead>
                <th>Producto</th>
                <th>Cantidad</th>
                <th>Precio</th>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item._id}>
                    <td>{item.name}</td>
                    <td>{item.quantity}</td>
                    <td>$ {item.price}</td>
                  </tr>
                ))}
                <tr>
                  <td colSpan="2" className="fw-bold text-end">
                    Costo de envío
                  </td>
                  <td>$ {totalPrice >= 1000 ? 0 : sendCost}</td>
                </tr>
                <tr>
                  <td colSpan="2" className="fw-bold text-end">
                    Total
                  </td>
                  <td>$ {totalPrice + (totalPrice >= 1000 ? 0 : sendCost)}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <hr />
          <p>Paga con tarjetas de débito y crédito</p>

          <div className="d-flex gap-2 mb-3 ">
            <img src="/img/visa.gif" className="" height="10px" alt="" />
            <img src="/img/oca.gif" className="" height="10px" alt="" />
            <img src="/img/creditel.png" className="" height="10px" alt="" />
            <img src="/img/master.svg" className="" height="10px" alt="" />
          </div>

          <Cards
            number={number}
            name={name}
            expiry={expiry}
            cvc={cvc}
            focused={focus}
            className="mt-5"
          />
          <form onSubmit={handdleSubmit}>
            <label for="inputCardNumber" className="fw-bold fs-6 mt-3 mb-2">
              Número de Tarjeta*
            </label>
            <input
              type="tel"
              name="number"
              placeholder="Card Number"
              className="form-control"
              maxLength={16}
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              onFocus={(e) => setFocus(e.target.name)}
              ref={ref}
            />
            <label for="inputCardName" className="fw-bold fs-6 mt-3 mb-2">
              Nombre del titular de la tarjeta*
            </label>
            <input
              type="text"
              name="name"
              placeholder="Name"
              maxlength="18"
              value={name}
              className="form-control"
              onChange={(e) => setName(e.target.value)}
              onFocus={(e) => setFocus(e.target.name)}
            />

            <label for="inputCardDate" className="fw-bold fs-6 mt-3 mb-2">
              Fecha de vencimiento*
            </label>
            <input
              type="tel"
              name="expiry"
              placeholder="MM/YY"
              maxlength="5"
              value={expiry}
              className="form-control"
              onChange={(e) => setExpiry(e.target.value)}
              onFocus={(e) => setFocus(e.target.name)}
            />

            <label for="inputCardCode" className="fw-bold fs-6 mt-3 mb-2">
              Código de seguridad*
            </label>
            <input
              type="tel"
              name="cvc"
              placeholder="CVC"
              maxlength="3"
              value={cvc}
              className="form-control"
              onChange={(e) => setCvc(e.target.value)}
              onFocus={(e) => setFocus(e.target.name)}
            />
            <button
              type="submit"
              id="buy-button"
              className="btn btn-dark rounded-pill d-block w-100 mt-3"
            >
              Comprar
            </button>
          </form>
        </Card.Body>
      </Card>
    </>
  );
}

export default OrderDetail;
